import React, {useState} from 'react'
import {CustomHeader} from './CustomHeader'
import {onlyDateFormat} from '../../../../components'
import ReactTooltip from 'react-tooltip'
import ProjectSelection from './ProjectSelection'
import ProjectSelectionHeader from './ProjectSelectionHeader'
import MemberModal from '../MemberModel'
import moment from 'moment'
import CaseStudyModal from '../CaseStudyModal'
import {fetchImage} from '../../core/_requests'
import {useQueryResponseRefetch} from '../../core/QueryResponseProvider'
import PulseLoader from 'react-spinners/PulseLoader'
import Swal from 'sweetalert2'
import RefreshIcon from '../../component/RefreshIcon'
import EyeIconSvg from '../../component/EyeIconSvg'

const ImagePreviewModal = ({imageUrl, imageUrls}: any) => {
  const [show, setShow] = useState(false)
  const [currentIndex, setCurrentIndex] = useState(0)

  // Determine if we have multiple images or single image
  const isMultiple = imageUrls && imageUrls.length > 0
  const images = isMultiple ? imageUrls : imageUrl ? [imageUrl] : []
  const currentImage = images[currentIndex] || imageUrl

  const nextImage = () => {
    if (isMultiple) {
      setCurrentIndex((prev) => (prev + 1) % images.length)
    }
  }

  const prevImage = () => {
    if (isMultiple) {
      setCurrentIndex((prev) => (prev - 1 + images.length) % images.length)
    }
  }

  return (
    <>
      <div data-tip={isMultiple ? 'View Images' : 'View Image'} onClick={() => setShow(true)}>
        <EyeIconSvg />
        <ReactTooltip />
      </div>

      {show && (
        <div className='modal fade show d-block' style={{backgroundColor: 'rgba(0,0,0,0.3)'}}>
          <div className='modal-dialog modal-xl modal-dialog-centered'>
            <div className='modal-content'>
              <div className='modal-header pt-3 pb-0'>
                <h5 className='modal-title w-100 text-center'>
                  {isMultiple
                    ? `Website Images (${currentIndex + 1}/${images.length})`
                    : 'Website Preview'}
                </h5>
                <button
                  type='button'
                  className='btn-close'
                  style={{
                    outline: 'none',
                    boxShadow: 'none',
                  }}
                  onClick={() => setShow(false)}
                />
              </div>

              <div className='modal-body p-3 d-flex justify-content-center align-items-center position-relative'>
                {/* Previous Button */}
                {isMultiple && images.length > 1 && (
                  <button
                    className='btn btn-light position-absolute start-0'
                    style={{zIndex: 10}}
                    onClick={prevImage}
                  >
                    <i className='fas fa-chevron-left'></i>
                  </button>
                )}

                {/* Image */}
                {currentImage && (
                  <img
                    src={currentImage}
                    alt={isMultiple ? `Website ${currentIndex + 1}` : 'Website Preview'}
                    style={{
                      // maxHeight: '80vh',
                      maxWidth: '100%',
                      objectFit: 'contain',
                    }}
                  />
                )}

                {/* Next Button */}
                {isMultiple && images.length > 1 && (
                  <button
                    className='btn btn-light position-absolute end-0'
                    style={{zIndex: 10}}
                    onClick={nextImage}
                  >
                    <i className='fas fa-chevron-right'></i>
                  </button>
                )}
              </div>

              {/* Image Indicators */}
              {/* {isMultiple && images.length > 1 && (
                <div className='modal-footer'>
                  <div className='d-flex justify-content-center gap-2'>
                    {images.map((_, index) => (
                      <button
                        key={index}
                        className={`btn btn-sm ${
                          index === currentIndex ? 'btn-primary' : 'btn-secondary'
                        }`}
                        onClick={() => setCurrentIndex(index)}
                      >
                        {index + 1}
                      </button>
                    ))}
                  </div>
                </div>
              )} */}
            </div>
          </div>
        </div>
      )}
    </>
  )
}

const UsersColumns = (loadingImageIndex, setLoadingImageIndex) => {
  const refetch: any = useQueryResponseRefetch()

  const [loading, setLoading] = useState(false)

  const imageFetching = async (row) => {
    const id = row?.original?.id
    const url = row?.original?.url || row?.original?.stagingUrl
    if (url) {
      try {
        const resp: any = await fetchImage(id, url)

        if (resp?.status === 200) {
          Swal.fire({
            toast: true,
            position: 'top-end',
            icon: 'success',
            title: resp.message || 'Image fetched successfully',
            showConfirmButton: false,
            timer: 5000,
          })

          refetch()
          setLoading(false)
          setLoadingImageIndex(null)
        } else {
          console.log(resp?.message)

          Swal.fire({
            toast: true,
            position: 'top-end',
            icon: 'error',
            title: 'Website loading issue encountered',
            showConfirmButton: false,
            timer: 5000,
          })

          setLoadingImageIndex(null)
          setLoading(false)
        }
      } catch (err: any) {
        console.log(err, 'error')

        Swal.fire({
          toast: true,
          position: 'top-end',
          icon: 'error',
          title: 'Website loading issue encountered',
          showConfirmButton: false,
          timer: 5000,
        })

        setLoadingImageIndex(null)
        setLoading(false)
      }
    } else {
      Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'error',
        title: 'Url not exists, add url first.',
        showConfirmButton: false,
        timer: 5000,
      })

      setLoadingImageIndex(null)
      setLoading(false)
    }
  }

  return [
    {
      Header: (props: any) => <ProjectSelectionHeader tableProps={props} />,
      id: 'selection',
      Cell: ({...props}) => {
        return (
          <ProjectSelection
            id={props.data[props.row.index].id}
            isDisabled={props.data[props.row.index]?.eNDAprotected === '1'}
          />
        )
      },
    },
    {
      Header: (props) => (
        <CustomHeader tableProps={props} title='Project' className='min-w-125px' />
      ),
      accessor: 'projectName',
      Cell: ({row}) => {
        // @ts-ignore: Unreachable code error
        return (
          <div className='row'>
            <div className='col-md-12'>
              <span className='text-dark fw-bolder text-hover-primary mb-1 fs-6'>
                {row?.original?.projectName}
              </span>
            </div>
          </div>
        )
      },
    },
    {
      Header: (props) => <CustomHeader tableProps={props} title='Client' className='min-w-200px' />,
      accessor: 'client',
      Cell: ({row}) => {
        // @ts-ignore: Unreachable code error
        return (
          <div className='row'>
            <div className='col-md-10'>
              <span className='text-dark fw-bolder text-hover-primary mb-1 fs-6'>
                {row?.original?.client}
              </span>
            </div>
          </div>
        )
      },
    },
    {
      Header: (props) => (
        <CustomHeader tableProps={props} title='Industry' className='min-w-200px' />
      ),
      id: 'industry',
      Cell: ({row}) => {
        // @ts-ignore: Unreachable code error
        return (
          <div className='row'>
            <div className='col-md-10'>
              <span className='text-dark fw-bolder text-hover-primary mb-1 fs-6'>
                {!Array.isArray(row?.original?.industry) ? (
                  <span className={`badge badge-secondary me-2 mb-1`}>
                    {row?.original?.industry}
                  </span>
                ) : (
                  ''
                )}
              </span>
            </div>
          </div>
        )
      },
    },
    {
      Header: (props) => (
        <CustomHeader tableProps={props} title='Start Date' className='min-w-125px' />
      ),
      accessor: 'startDate',
      Cell: ({row}) => {
        return (
          <span className='text-dark fw-bolder text-hover-primary  mb-1 fs-6'>
            {onlyDateFormat(row?.original?.startDate, 'YYYY-MM-DD')}
          </span>
        )
      },
    },
    {
      Header: (props) => (
        <CustomHeader
          tableProps={props}
          title='Service'
          className='min-w-200px'
          isSortable={false}
        />
      ),
      id: 'service',
      Cell: ({row}) => {
        // @ts-ignore: Unreachable code error
        return (
          <div className='row'>
            <div className='col-md-10'>
              <span className='text-dark fw-bolder text-hover-primary mb-1 fs-6'>
                {row?.original?.service?.length !== 0
                  ? row?.original?.service &&
                    row?.original?.service?.map((item: any, index: any) => (
                      <span className={`badge badge-secondary me-2 mb-1`} key={`tag-${index}`}>
                        {item?.vName}
                      </span>
                    ))
                  : ''}
              </span>
            </div>
          </div>
        )
      },
    },
    {
      Header: (props) => (
        <CustomHeader
          tableProps={props}
          title='Technology'
          className='min-w-200px'
          isSortable={false}
        />
      ),
      id: 'technology',
      Cell: ({row}) => {
        // @ts-ignore: Unreachable code error
        return (
          <div className='row'>
            <div className='col-md-10'>
              <span className='text-dark fw-bolder text-hover-primary mb-1 fs-6'>
                {row?.original?.technology?.length !== 0
                  ? row?.original?.technology &&
                    row?.original?.technology?.map((item: any, index: any) => (
                      <span className={`badge badge-secondary me-2 mb-1`} key={`tag-${index}`}>
                        {item?.vName}
                      </span>
                    ))
                  : ''}
              </span>
            </div>
          </div>
        )
      },
    },
    {
      Header: (props) => (
        <CustomHeader
          tableProps={props}
          title='Framework'
          className='min-w-200px'
          isSortable={false}
        />
      ),
      id: 'framework',
      Cell: ({row}) => {
        // @ts-ignore: Unreachable code error
        return (
          <div className='row'>
            <div className='col-md-10'>
              <span className='text-dark fw-bolder text-hover-primary mb-1 fs-6'>
                {row?.original?.framework?.length !== 0
                  ? row?.original?.framework &&
                    row?.original?.framework?.map((item: any, index: any) => (
                      <span className={`badge badge-secondary me-2 mb-1`} key={`tag-${index}`}>
                        {item?.vName}
                      </span>
                    ))
                  : ''}
              </span>
            </div>
          </div>
        )
      },
    },
    {
      Header: (props) => (
        <CustomHeader
          tableProps={props}
          title='NDA Protected'
          className='min-w-150px'
          isSortable={false}
        />
      ),
      id: 'eNDAprotected',
      Cell: ({row}) => {
        const getClass: string = (() => {
          switch (row.original.eNDAprotected) {
            case '0':
              return 'light-danger'
            case '1':
              return 'light-success'
            default:
              return 'light-danger'
          }
        })()
        // @ts-ignore: Unreachable code error
        return (
          <div className='row'>
            <div className='col-md-10'>
              <div className={`badge badge-${getClass}`}>
                {row.original.eNDAprotected === '1' ? 'Yes' : 'No'}
              </div>
            </div>
          </div>
        )
      },
    },
    {
      Header: (props) => (
        <CustomHeader tableProps={props} title='URL' isSortable={false} className='min-w-150px' />
      ),
      accessor: 'url',
      Cell: ({row}) => {
        // @ts-ignore: Unreachable code error
        return (
          <div className='d-flex flex-column gap-2'>
            {/* Live URL Row */}
            {row.original.url?.trim() && (
              <div>
                <span className='text-dark fw-bolder fs-6'>Live URL:</span>

                <div className='d-flex align-items-center justify-content-between'>
                  <a
                    href={row.original.url}
                    target='_blank'
                    rel='noopener noreferrer'
                    className='custom-link text-decoration-underline'
                  >
                    {row.original.url}
                  </a>

                  <button
                    type='button'
                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm ms-2'
                    onClick={(e) => {
                      e.preventDefault()
                      e.stopPropagation()
                      if (row.original.url) {
                        navigator.clipboard.writeText(row.original.url)
                        Swal.fire({
                          toast: true,
                          position: 'top-end',
                          icon: 'success',
                          title: 'Live URL Copied!',
                          showConfirmButton: false,
                          timer: 2000,
                        })
                      }
                    }}
                  >
                    <i className='fas fa-copy'></i>
                  </button>
                </div>
              </div>
            )}

            {/* Staging URL Row */}
            {row.original.stagingUrl?.trim() && (
              <div>
                <span className='text-dark fw-bolder fs-6'>Staging URL:</span>

                <div className='d-flex align-items-center justify-content-between'>
                  <a
                    href={row.original.stagingUrl}
                    target='_blank'
                    rel='noopener noreferrer'
                    className='custom-link text-decoration-underline'
                  >
                    {row.original.stagingUrl}
                  </a>

                  <button
                    type='button'
                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm ms-2'
                    onClick={(e) => {
                      e.preventDefault()
                      e.stopPropagation()
                      if (row.original.stagingUrl) {
                        navigator.clipboard.writeText(row.original.stagingUrl)
                        Swal.fire({
                          toast: true,
                          position: 'top-end',
                          icon: 'success',
                          title: 'Staging URL Copied!',
                          showConfirmButton: false,
                          timer: 2000,
                        })
                      }
                    }}
                  >
                    <i className='fas fa-copy'></i>
                  </button>
                </div>
              </div>
            )}
          </div>
        )
      },
    },
    {
      Header: (props) => (
        <CustomHeader
          tableProps={props}
          title='Url Status'
          className='min-w-125px'
          isSortable={false}
        />
      ),
      accessor: 'urlStatus',
      Cell: ({row}) => {
        return (
          <div className='row'>
            <div className='col-md-10 d-flex justify-content-end'>
              {row?.original?.urlStatus !== '0' && row.original.urlStatus !== '' ? (
                <span className='text-dark fw-bolder text-hover-primary  mb-1 fs-6'>
                  {row.original.urlStatus}
                </span>
              ) : (
                ''
              )}
            </div>
          </div>
        )
      },
    },

    {
      Header: (props) => (
        <CustomHeader
          tableProps={props}
          title='Last Health Check'
          className='min-w-200px'
          isSortable={false}
        />
      ),
      accessor: 'dHealthCheckedDate',
      Cell: ({row}) => {
        return (
          <div className='row'>
            <div className='col-md-12'>
              <span className='text-dark fw-bolder text-hover-primary mb-1 fs-6'>
                {row?.original?.dHealthCheckedDate
                  ? moment(row?.original?.dHealthCheckedDate).format('DD-MMM-YYYY')
                  : '-'}
              </span>
            </div>
          </div>
        )
      },
    },

    {
      Header: (props) => (
        <CustomHeader
          tableProps={props}
          title='Response Time (sec)'
          className='min-w-150px'
          isSortable={false}
        />
      ),
      accessor: 'responseTime',
      Cell: ({row}: any) => {
        return (
          <div className='row'>
            <div className='col-md-12'>
              <span className='text-dark fw-bolder text-hover-primary mb-1 fs-6'>
                {row?.original?.responseTime?.toLocaleString('en-IN', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }) || '-'}
              </span>
            </div>
          </div>
        )
      },
    },

    {
      Header: (props) => (
        <CustomHeader
          tableProps={props}
          title='Point Of Contact'
          className='min-w-150px align-content-center'
          isSortable={false}
        />
      ),
      accessor: 'pmPl',
      Cell: ({row}: any) => {
        const members = row?.original?.pmPl || []
        const [open, setOpen] = React.useState(false)

        if (!members.length) {
          return <div className='d-flex justify-content-center align-items-center'>-</div>
        }

        return (
          <>
            <div className='d-flex justify-content-center align-items-center'>
              <span
                data-tip='View Image'
                className='text-primary fw-bold cursor-pointer'
                onClick={() => setOpen(true)}
              >
                <EyeIconSvg />
                <ReactTooltip />
              </span>
            </div>

            <MemberModal show={open} onClose={() => setOpen(false)} members={members} />
          </>
        )
      },
    },

    {
      Header: (props) => (
        <CustomHeader
          tableProps={props}
          title='Website Preview'
          className='min-w-150px'
          isSortable={false}
        />
      ),
      accessor: 'websiteUrl',
      Cell: ({row}: any) => {
        const image = row?.original?.portfolio?.autoCapturedWebsiteImageUrl || ''

        return image ? (
          <div className='d-flex align-items-center justify-content-center gap-4'>
            <ImagePreviewModal imageUrl={image} />
            {loadingImageIndex === row?.index && loading ? (
              <span>
                <RefreshIcon isLoading={true} />
              </span>
            ) : (
              <div
                data-tip='Recapture Image'
                className='cursor-pointer'
                onClick={() => {
                  setLoadingImageIndex(row?.index)
                  setLoading(true)
                  imageFetching(row)
                }}
              >
                <RefreshIcon />
                <ReactTooltip />
              </div>
            )}
          </div>
        ) : row?.original?.url || row?.original?.stagingUrl ? (
          loadingImageIndex === row?.index && loading ? (
            <div className='d-flex align-items-center justify-content-center'>
              <button
                type='button'
                onClick={() => {
                  return
                }}
                className='d-flex btn btn-sm btn-primary cursor-not-allowed'
              >
                Fetching Image
                <div>
                  <PulseLoader
                    color='#ffffff'
                    size={'3px'}
                    loading={loadingImageIndex === row?.index}
                  />
                </div>
              </button>
            </div>
          ) : (
            <button
              type='button'
              onClick={() => {
                setLoadingImageIndex(row?.index)
                setLoading(true)

                imageFetching(row)
              }}
              disabled={loading}
              className='btn btn-sm btn-primary cursor-pointer'
            >
              Add Image
            </button>
          )
        ) : (
          <span>-</span>
        )
      },
    },
    {
      Header: (props) => (
        <CustomHeader
          tableProps={props}
          title='Website Images'
          className='min-w-150px'
          isSortable={false}
        />
      ),
      accessor: 'websiteImages',
      Cell: ({row}: any) => {
        const websiteImages = row?.original?.portfolio?.websiteImageUrls || []

        return websiteImages && websiteImages.length > 0 ? (
          <div className='d-flex align-items-center justify-content-center'>
            <ImagePreviewModal imageUrls={websiteImages} />
          </div>
        ) : (
          <div className='d-flex align-items-center justify-content-center'>
            <span>-</span>
          </div>
        )
      },
    },
    {
      Header: (props) => (
        <CustomHeader
          tableProps={props}
          title='Case Study'
          className='min-w-150px align-content-center'
          isSortable={false}
        />
      ),
      id: 'caseStudy',
      Cell: ({row}: any) => {
        const portfolioData = row?.original?.portfolio

        // Check if at least one portfolio field has content
        const hasPortfolio =
          portfolioData &&
          ((portfolioData.vWhatWeDid && portfolioData.vWhatWeDid.trim() !== '') ||
            (portfolioData.vPortfolioChallenges &&
              portfolioData.vPortfolioChallenges.trim() !== '') ||
            (portfolioData.vHowWeSolved && portfolioData.vHowWeSolved.trim() !== '') ||
            (portfolioData.vTechStackUsed && portfolioData.vTechStackUsed.trim() !== ''))

        const [open, setOpen] = React.useState(false)

        if (!hasPortfolio) {
          return <div className='d-flex justify-content-center align-items-center'>-</div>
        }

        return (
          <>
            <div className='d-flex justify-content-center align-items-center'>
              <span
                data-tip='View Image'
                className='text-primary fw-bold cursor-pointer'
                onClick={() => setOpen(true)}
              >
                <EyeIconSvg />
                <ReactTooltip />
              </span>
            </div>

            <CaseStudyModal
              show={open}
              onClose={() => setOpen(false)}
              portfolioData={portfolioData}
            />
          </>
        )
      },
    },
  ]
}

export default UsersColumns
